import {Typography} from 'components/Typography';
import {getPhone} from 'core/helpers/phone';
import {FC, useMemo} from 'react';
import style from './style.module.scss';
import classNames from 'classnames';
import Link from 'next/link';
import {MetroStationWalkingTime} from 'modules/wineshops-list/components/MetroStationWalkingTime';
import {useRouter} from 'next/router';
import {useGetEventQuery} from 'modules/events/services';

export const EventPlace: FC = () => {
    const {query} = useRouter();
    const {data} = useGetEventQuery({id: query.slug as string});
    const event = data?.data;

    const resultPhone = useMemo(() => {
        if (!event) {
            return '';
        }

        const {additionalPhone, phoneNumber} = event.winery.phone;

        return getPhone(phoneNumber, additionalPhone);
    }, [event]);

    if (!event) {
        return null;
    }

    const {address, hasDegustationHall, phone, title, url, metroStations = []} = event.winery;

    return (
        <div className={classNames(hasDegustationHall ? style.hasDegustationHall : '')}>
            <Typography variant={'price-20-b'}>Место проведения</Typography>
            <div className={style.content}>
                <img alt={''} className={style.image} src={'/images/tastingHall.svg'} />
                <div>
                    <Typography className={style.degustationHallTitle} variant={'body-16-r'}>
                        Дегустационный зал
                    </Typography>
                    <Link href={url}>
                        <Typography className={style.title} element={'div'} variant={'body-16-r'}>
                            {title}
                        </Typography>
                    </Link>
                    <Typography className={style.address} element={'div'} variant={'body-16-r'}>
                        {address}
                    </Typography>
                    {0 < metroStations.length && (
                        <div className={style.metro}>
                            {metroStations.map((metro) => {
                                const {name, hexColor} = metro;
                                return (
                                    <MetroStationWalkingTime
                                        key={name}
                                        hexColor={hexColor}
                                        name={name}
                                        nameTextVariant={'label-16-r'}
                                    />
                                );
                            })}
                        </div>
                    )}
                    <a className={style.phoneLink} href={`tel:${phone.url}`}>
                        <Typography variant={'body-16-r'}>{resultPhone}</Typography>
                    </a>
                </div>
            </div>
        </div>
    );
};
